import {
  POSTCODE_REGEX,
  EMAIL_REGEX,
  CAR_REGISTRATION_REGEX,
  LOAN_AMOUNT_REGEX,
  LOAN_LENGTH_REGEX,
  UK_PHONE_REGEX,
} from '../../constants/regex'

export default {
  email: {
    pattern: {
      value: EMAIL_REGEX,
      message: 'Please enter a valid email address',
    },
  },
  postcode: {
    pattern: {
      value: POSTCODE_REGEX,
      message: 'Please enter a valid postcode',
    },
  },
  carRegistration: {
    pattern: {
      value: CAR_REGISTRATION_REGEX,
      message: 'Please enter a valid car registration',
    },
  },
  loanAmount: {
    pattern: {
      value: LOAN_AMOUNT_REGEX,
      message: 'The value should be between £1,000-£50,000',
    },
  },
  loanLength: {
    pattern: {
      value: LOAN_LENGTH_REGEX,
      message: 'The loan length should be between 1-10 years',
    },
  },
  phoneNumber: {
    pattern: {
      value: UK_PHONE_REGEX,
      message: 'Please enter a valid UK phone number',
    },
  },
}
